export enum StudentLicenseStatus {
  SEM_HABILITACAO = "SEM_HABILITACAO",
  EM_PROCESSO = "EM_PROCESSO",
  HABILITADO = "HABILITADO",
}
